<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";

var data = [
  {
    name: "大黄姜",
    value: 30.2,
  },
  {
    name: "小黄姜",
    value: 26.9,
  },
  {
    name: "姜种",
    value: 9,
  },
  {
    name: "仔姜",
    value: 12.7,
  },
  {
    name: "老姜",
    value: 10,
  },
  {
    name: "其它",
    value: 11.2,
  },
];

const option = {
  color: [
    "#FCD31F",
    "#03FF4A",
    "#037CFF",
    "#FF7723",
    "#40FFE5",
    "#11D1F7",
    "rgba(250,250,250,0.3)",
  ],
  // backgroundColor: "#081736",
  title: {
    text: "采购",
    // subtext: "13000吨",

    textStyle: {
      color: "#f2f2f2",
      fontSize: 40,
    },
    subtextStyle: {
      fontSize: 30,

      color: ["#ff9d19"],
    },

    x: "42%",
    y: "30%",
  },

  grid: {
    bottom: 250,
    left: 100,
    right: "10%",
  },
  legend: {
    orient: "vertical",
    icon: "rect",
    top: "67%",
    left: "20%",
    textStyle: {
      color: "#f2f2f2",
      fontSize: 25,
      lineHeight: 30,
      padding: [0, 0, 0, 2],
    },

    // itemGap: 10,
    // data: data,
    // formatter: function (params) {
    //   return params.name + "\n" + params.value + "%";
    // },
    //图例标记的图形高度
    itemHeight: 20,
    //图例标记的图形宽度
    itemWidth: 20,
    formatter: function (name) {
      let res = data.filter((v) => v.name === name);
      res = res[0] || {};
      const p = res.value;
      return name + "\n" + p + "%"; // return "{name|" + name + "}";
    },
  },

  series: [
    // 主要展示层的
    {
      radius: ["30%", "45%"],
      center: ["50%", "35%"],
      type: "pie",
      label: {
        normal: {
          show: false,
          formatter: "{c}%",
          textStyle: {
            fontSize: 30,
          },
          position: "outside",
        },
        emphasis: {
          show: true,
        },
      },
      labelLine: {
        normal: {
          show: true,
          length: 30,
          length2: 55,
        },
        emphasis: {
          show: true,
        },
      },
      name: "民警训练总量",
      data: data,
    },
    // 边框的设置
    {
      radius: ["30%", "34%"],
      center: ["50%", "35%"],
      type: "pie",
      label: {
        normal: {
          show: false,
        },
        emphasis: {
          show: false,
        },
      },
      labelLine: {
        normal: {
          show: false,
        },
        emphasis: {
          show: false,
        },
      },
      animation: false,
      tooltip: {
        show: false,
      },
      data: [
        {
          value: 1,
          itemStyle: {
            color: "rgba(250,250,250,0.3)",
          },
        },
      ],
    },
    {
      name: "外边框",
      type: "pie",
      clockWise: false, //顺时加载
      hoverAnimation: false, //鼠标移入变大
      center: ["50%", "35%"],
      radius: ["55%", "55%"],
      label: {
        normal: {
          show: false,
        },
      },
      data: [
        {
          value: 9,
          name: "",
          itemStyle: {
            normal: {
              borderWidth: 20,
              borderColor: "#0b5263",
            },
          },
        },
      ],
    },
  ],
};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);

    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
